import React, { useState } from 'react';
import { Box, Typography, Avatar, IconButton } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

function ClinicHeaderItem({ title, subtitle, age, thumbUrl, onEdit, onDelete }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        //padding: 1, // equivalente a android:padding="8dp"
        width: '100%',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Imagen de avatar */}
      <Avatar
        sx={{
          width: 35,
          height: 35,
        }}
        src={thumbUrl}
      >
        {!thumbUrl && (
          <PersonIcon />
        )}
      </Avatar>

      {/* Contenedor del texto */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginLeft: 2, // equivalente a android:layout_marginStart="8dp"
          flex: 1, // esto hace que el texto ocupe el resto del espacio
        }}
      >
        {/* Título */}
        <Typography
          variant="h6"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: 13, // equivalente a android:textSize="13sp"
            fontWeight: 'bold',
          }}
        >
          {title}
        </Typography>

        {/* Subtítulo */}
        <Typography
          variant="body2"
          sx={{
            fontSize: 12, // equivalente a TextAppearance.AppCompat.Caption
            color: 'text.secondary',
          }}
        >
          {subtitle}
        </Typography>

        {/* Edad (visible si se pasa como prop) */}
        {age && (
          <Typography
            variant="body2"
            sx={{
              fontSize: 12, // equivalente a TextAppearance.AppCompat.Caption
              color: 'text.secondary',
            }}
          >
            {age}
          </Typography>
        )}
      </Box>

      {/* Botones de acción */}
      {(onEdit || onDelete) && (
        <Box 
          sx={{ 
            display: 'flex', 
            gap: 1,
            opacity: isHovered ? 1 : 0,
            transition: 'opacity 0.2s ease-in-out'
          }}
        >
          {onEdit && (
            <IconButton 
              size="small" 
              onClick={onEdit}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          )}
          {onDelete && (
            <IconButton 
              size="small" 
              onClick={onDelete}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      )}
    </Box>
  );
}

export default ClinicHeaderItem;
